export const TABLE_SET = 'set'
export const TABLE_CHECK_IN = 'checkIn'
export const TABLE_IN_SHOP_SCAN = 'inShopScan'
export const TABLE_IMPLANT_3DSCAN = 'implant3dScan'
export const TABLE_IMPLANT_PLAN = 'implantPlan'
export const TABLE_IMPLANT_TREATMENT = 'implantTreatment'
export const TABLE_SHOP_SCAN = 'shopScan'
export const TABLE_TREATMENT = 'treatment'
export const TABLE_REFINEMENT_PRODUCTION = 'refinementProduction'
export const TABLE_REFINEMENT_SET = 'refinementSet'
export const TABLE_REFINEMENT_BOOKING = 'refinementBooking'
export const TABLE_REFINEMENT_SHOP = 'refinementShop'
export const TABLE_RETAINER = 'retainer'
export const TABLE_RETAINER_REFINEMENT = 'retainerRefinement'
export const TABLE_ESCALATION = 'escalation'
export const TABLE_END_OF_TREATMENT = 'endOfTreatment'




// WEBPACK FOOTER //
// ./src/modules/sales-order/state/search/type.js